import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let checkUserLogin = !!this.authService.getToken();

    if (state.url.includes('/roche-psp') && !checkUserLogin) {
      this.router.navigate(['auth/login/phone']);
      return false;
    }

    if (!checkUserLogin) {
      this.router.navigate(['auth/login']);
      return false;
    }

    return checkUserLogin;
  }
}
